import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TunapayService  extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  crieSessao(guid: string) {
    return this.facaPost(`/tunapay/cartao/nova-sessao/${guid}`, {});
  }


}
